export const types = { //types que se utilizan en los reducers
    login: '[Auth] login',
    logout: '[Auth] logout',

    nominaAdd: '[Nomina] add',
    nominaDelete: '[Nomina] delete',
    nominaRead: '[Nomina] read',
    nominaClean: '[Nomina] clean'
}